<div class="p-grid">
    <div class="p-col-12">
        <p-menu #configmenu id="config_menu" [model]="configMenuItems" [popup]="true"></p-menu>
        <div *ngIf="!hideAddEdit" class="tabviewIcons">
            <div class="btnBars" pTooltip="Minimize" tooltipPosition="top" (click)="menuShow('table')" *ngIf="isLeftTableHide">
                <i class="pi pi-minus-circle"></i>
            </div>
            <div class="btnBars" pTooltip="Maximize" tooltipPosition="top" (click)="menuHide('table')" *ngIf="!isLeftTableHide">
                <i class="pi pi-plus-circle"></i>
            </div>
            <div class="btnBars" pTooltip="Show Menu Bar" tooltipPosition="top" (click)="menuShow('menu')" *ngIf="!isMenuShow">
                <i class="pi pi-arrow-down"></i>
            </div>
            <div class="btnBars" pTooltip="Hide Menu Bar" tooltipPosition="top" (click)="menuHide('menu')" *ngIf="isMenuShow">
                <i class="pi pi-arrow-up"></i>
            </div>
            <div class="btnBars" (click)="openLeadMenu(); configmenu.toggle($event)">
                <i class="pi pi-bars"></i>
            </div>
            <div class="btnBars" (click)="cancelLeadDetail()">
                <i class="pi pi-times"></i>
            </div>
        </div>
        <p-tabView (onChange)="changeTab($event)" [(activeIndex)]="selectedTabIndex" class="custom-tablist custom-subtablist">
            <p-tabPanel header="Overview">
                <div *ngIf="selectedTabIndex === 0">
                    <div *ngIf="!hideAddEdit" class="arrow-steps">
                        <div class="p-grid">
                            <div class="p-col-12">
                                <div style="overflow-x: auto; width: 100%;">
                                    <ng-container *ngFor="let stage of leadStages; let i = index;">
                                        <div class="step"
                                            [ngClass]="{
                                                'current': (selectedLead.leadStageId == stage.id) ||
                                                    ([5, 6].includes(selectedLead.leadStageId) && stage.id === -1),
                                                'handPointer': !editPermission
                                            }"
                                            [ngStyle]="{
                                                width: leadStages.length > 2 ?
                                                (100 / leadStages.length) + '%' : '10%', maxWidth: 100 / leadStages.length > 2
                                                ? (100 / leadStages.length) + '%' : '15%'
                                            }"
                                            [class.inactive]="selectedLead.statusId !== 1 || selectedLead.isConvertedToAccount"
                                            (click)="openUpdateStagePopupChild(stage.id, 'Add')">
                                            <span>
                                                {{ stage.name }}
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-m-2">
                        <app-account-lead-detail-block [moduleId]="leadModuleId" [column]="savedLeadListDetailCols"
                            [data]="filteredLeads" [qualifiedId]="qualifiedId" (reloadDetails)="reloadLeadDetails($event)">
                        </app-account-lead-detail-block>

                        <!-- <app-lead-details-subtabs [tabList]="subTabList" [isLeftTableHide]="isLeftTableHide"></app-lead-details-subtabs> -->
                    </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Activity">
                <app-shared-activities-timeline *ngIf="selectedTabIndex === leadViewTabIndex?.ACTIVITY" [objectId]="selectedLeadFromTable"
                    [isViewMode]="selectedLead.statusId != 1" objectType="Lead" [selectedObject]="selectedLead"
                    [hideRigthArrow]="hideAddEdit" [selectedObjectStages]="leadStages" [contacts]="leadContacts"
                    (object)="onCommentSavedChild($event)" (taskAdded)="onAddTask($event)"
                    [hideEmailSyncIcon]="selectedLead.isConvertedToAccount"
                    [objectTypeId]="objectTypeId" [channelId]="filteredLeads?.typeId">
                </app-shared-activities-timeline>
            </p-tabPanel>
            <p-tabPanel header="List">
                <div *ngIf="selectedTabIndex == leadViewTabIndex.List">
                    <app-sublist-details-popup [tabList]="subTabList" [isLeftTableHide]="isLeftTableHide"></app-sublist-details-popup>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Contacts" *ngIf="contactModulePermission">
                <lion-shared-contacts *ngIf="selectedTabIndex === leadViewTabIndex?.CONTACT" [contacts]="leadContacts"
                    (contactAdded)="getLeadDetails($event)" [isViewMode]="selectedLead.statusId != 1"
                    (contactUpdated)="postContactEditChild($event)" [addUpdateDone]="addUpdateDone"
                    (contactInfo)="addLeadContactChild($event)" [allAssociationNamesList]="leadsData" [selectedChannel]="selectedChannelInfo"
                    [object]="selectedLead" [contactAssociationId]="contactAssociationId" moduleName="Lead"
                    [isDisableAssociation]="true" [hideRigthArrow]="hideAddEdit">
                </lion-shared-contacts>
            </p-tabPanel>
           <!-- ---------------------------------------------- Lead Documents-->
           <p-tabPanel  header="Documents" >
                <!-- <lead-detail-documents *ngIf="selectedTabIndex === leadViewTabIndex?.DOCUMENTS" [selectedLead]="selectedLead" [selectedChannel]="selectedChannel" [selectedTabIndex]="selectedTabIndex" [leadViewTabIndex]="leadViewTabIndex"></lead-detail-documents> -->
                <app-documents-management *ngIf="selectedTabIndex === leadViewTabIndex?.DOCUMENTS" [displayDocumentList]="true" [selectedData]="selectedLead" [selectedModuleId]="leadModuleId" [selectedChannel]="selectedChannel"></app-documents-management>
            </p-tabPanel>
           <!-- ------------------------------------------------------------------- -->
            <!---- Dynamic Tab List -------->

            <ng-container *ngFor="let subtabDetails of tabList; let i = index">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <div (click)="selectSubTab(i)" class="p-d-flex p-ai-center custom-tab-name">
                            <span style="white-space: nowrap;">{{ subtabDetails?.widgetName }}</span>
                            <!-- <span class="pi pi-times widget-delete-icon" (click)="deleteSublist(subtabDetails)"></span> -->
                        </div>
                    </ng-template>

                    <ng-container [ngSwitch]="subtabDetails?.referenceTypeName">
                        <ng-container *ngSwitchCase="'SavedSearch'">
                            <app-saved-search-table-view *ngIf="activeTabIndex==i"
                                [tabWidgetDetails]="subtabDetails"
                                [savedSearchId]="subtabDetails.referenceId"
                                [showFlatTable]="true"
                                [isLeftTableHide]="isLeftTableHide"
                                [hideTableHeader]="true">
                            </app-saved-search-table-view>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Workbook'">
                            <app-shared-workbook-listing *ngIf="activeTabIndex==i"
                                [tabWidgetDetails]="subtabDetails"
                                [workbookIntId]="subtabDetails.referenceId"
                                [isLeftTableHide]="isLeftTableHide"
                                >
                            </app-shared-workbook-listing>
                        </ng-container>
                    </ng-container>
                </p-tabPanel>
            </ng-container>

            <!---- Dynamic Tab List End --->
        </p-tabView>
    </div>
</div>
